import { Injectable } from '@angular/core';
import { UtilService } from '../../Util/Util'
import { StorageService } from '../../storage/storage.service';
import { ShareDataService } from '../../share-data/share-data.service';
import { AuthGuardService } from '../../auth/auth-guard.service';

@Injectable({
  providedIn: 'root'
})
export class ParentService {
   // interface simlate
   routeOption = {
    token : { key : '', secretkey : '',account_id : '', schema : '' , time_zone : '' },
    login : { username : '', password:''},
    validatebus : { job_id : '', bookDateFrom: '', bookDateUntil: '' },
    sendEmail :{
      email_type:"ad-hoc",
      input: { passenger_id: []}
    }
  
  }
  route = {
    token : "parentportal/token" , 
    setting: "parentportal/setting",
    login : "login",
    // seachRoute : 'parentportal/route/contract/:current_lat/:current_lng',
    seachRoute : 'parentportal/route/contract',
    studentList : '/parentportal/student/list',
    studentInfo : '/parentportal/student/full',
    busRoute : '/parentportal/route/:ampm/:page',
    termAndCondition : '/parentportal/account/term',
    jobInfo : '/parentportal/route/view/:job_id',
    mychildren : '/parentportal/route/children',
    termsLog : '/parentportal/terms/log',
    insertPassengerToRoute : '/parentportal/passenger/contract',
    checkEmailVerify : '/prepareEmailVerify',
    sendSMS : '/sendSMS',
    sendOTP : '/sendOTP',
    verifyOtp : '/verifyOtp',
    graphql : '/graphql',
    exceptionList : 'children/exception/:page',
    validateBus : '/parentportal/contract/validatebus',
    exceptionValidate : '/children/exceptionvalid/:routetype',
    getException : '/children/getException/:eventID',
    sendEmail : '/sendEmail',
    busLateRoute : '/parentportal/route/:ampm/:page/:job_name',
    routeAvailableDay : '/parentportal/routeAvailableDay',
    insertPassengerToRouteTemp : '/parentportal/passenger/contractTemp',
    getAllContract : 'parentportal/getAllContract',
    removePassengerToRouteTemp : '/parentportal/passenger/removeContractTemp',
    
  }

  // service method //
  constructor(
    private axios,
    private utilService : UtilService,
    private storageService: StorageService,
    private shareDataService: ShareDataService
    ) { }

  public post  = (route: string , body : object, options : object ) => new Promise(async (resolve, reject) => {
      this.axios.post(route,  body , options)
      .then(res => {
        resolve(res.data);
      }).catch(async (error) => {
        console.log('post error:', error);
        console.log('post error:', error.response);
        if( error.response ){
          let errorBody = error.response.data;
          if (errorBody.indexOf("jwt expired") >= 0) {
            let tokenType = options['headers']?._ath
            await this.handleExpired(tokenType);
            if (tokenType == 0) {
              let res = await this.post(route, body, this.requestSecret())
              resolve(res)
            }
          }
        }
        reject({
          error: true,
          message: error
        });
      });
  })

  public get  = (route: string , param : string , options : object ) => new Promise(async (resolve, reject) => {
    this.axios.get(route + param,  options)
    .then(res => {
      resolve(res.data);
    }).catch(async (error, ext) => {
      console.log('get error:', error);
      console.log('get error:', error.response);
      if( error.response ){
        let errorBody = error.response.data;
        if (errorBody.indexOf("jwt expired") >= 0) {
          let tokenType = options['headers']?._ath
          await this.handleExpired(tokenType)
          if (tokenType == 0) {
            let res = await this.get(route, param, this.requestSecret())
            resolve(res)
          }
        }
      }
      reject({
        error: true,
        message: error
      });
    });
       
   })

   public handleExpired = (tokenType=0) => new Promise(async (resolve, reject) =>{
    if (tokenType == 1) {
      let msg = JSON.stringify({
        event: AuthGuardService.EVENT.LOGIN_TOKEN_EXPIRE
      })
      this.shareDataService.changeMessage(msg)
      return
    }

    let route = this.route.token;
    let data = this.routeOption.token;
    let env = this.utilService.getEnv();
    data.account_id = env['account_id'];
    data.key =  env['key'];
    data.schema =  env['schema'];
    data.secretkey =  env['secretkey'];
    data.time_zone =  env['time_zone'];

    this.post(route, data, {}).then(async (result) => {
      this.storageService.setStorage('token', result['token']);
      resolve(true)
    }).catch((err) => {
      console.log('err:', err);
      resolve(true)
    })
  })
  
    requestHeaderUser(){
      let userToken = this.storageService.getStorage('user');
      userToken =  JSON.parse(userToken);
      let optionsHeader = {
        headers: {
          'Authorization': 'Bearer ' + userToken['token'],
          '_ath': 1
        }
      }
      return optionsHeader;
    }
    
    async checkRequestSecretFirst(){
      let Secret = await this.requestSecret();
      if(Secret.headers.Authorization == "Bearer null"){
        //get secret token first time
        await this.handleExpired()
      }
    }
  
    requestSecret(){
      let secretToken = this.storageService.getStorage('token');
      let optionsHeader = {
        headers: {
          'Authorization': 'Bearer ' + secretToken,
          '_ath': 0
        }
      }
      return optionsHeader;
    }
  }
  

 
   
  //  public handdleExpired = (route: string , param : string , options : object ) => new Promise(async (resolve, reject) => {
  //   this.axios.get(route + param,  options)
  //         .then(res => {
  //           resolve(res.data);
  //         }).catch((error) => {
  //           reject({
  //             error: true,
  //             message: error
  //           });
  //         });
       
  //  })

  // public signIn = (email: string, passwords: string) => new Promise(async (resolve, reject) => {
  //   this.axios.post(`login`,  { username: email, password: passwords })
  //     .then(res => {
  //       resolve(res.data);
  //     }).catch((error) => {
  //       reject({
  //         error: true,
  //         message: error
  //       });
  //     });
  // })

  // public prepareEmailVerify = (email: string) => new Promise(async (resolve, reject) => {
  //   this.axios.post(`prepareEmailVerify`,  {email})
  //     .then(res => {
  //       resolve(res.data);
  //     }).catch((error) => {
  //       reject({
  //         error: true,
  //         message: error
  //       });
  //     });
  // })

  // public callSms = (phonenumber, token) => new Promise(async (resolve, reject) => {

  //   const headers = {
  //     authorization: 'Bearer ' + token,
  //     'Content-Type' : 'application/json'
  //   };
  //   this.axios.defaults.headers = headers;
  //   const otp = Math.floor(Math.random() * 900000) + 100000;
  //   const bodyParameters = {
  //     text: 'Here is your one-time 6 digit verification code for the Parent App. This code will expire in 5 minutes, ' + otp,
  //     to: phonenumber
  //   };
  //   this.axios.post('sendSMS', bodyParameters)
  //     .then(res => {
  //       resolve(res.data);
  //     }).catch((error) => {
  //       reject({
  //         error: true,
  //         message: error
  //       });
  //     });
  // })



// export interface ParentRuote {
//   r: number;
//   gameName: string;
//   gameCode: string;
//   releaseDate: string;
//   price: number;
//   description: string;
//   thumbRating: number;
//   imageUrl: string;
// }
